module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-10 col-lg-10"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content padding-top"
  }, _vm._l((_vm.travelDocuments), function(travelDocument) {
    return _c('div', {
      staticClass: "card-row"
    }, [_c('div', {
      staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8"
    }, [_c('span', [_vm._v(_vm._s(travelDocument.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4"
    }, [_c('button', {
      staticClass: "md-btn pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.downloadTravelDocument(travelDocument)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.passengers), function(passenger) {
    return (passenger.documents.length > 0) ? _c('div', {
      staticClass: "grid-container"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v("Reisdocumenten " + _vm._s(_vm.formatName(passenger)))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, _vm._l((passenger.documents), function(document) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8"
      }, [_c('span', [_vm._v(_vm._s(document.name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4"
      }, [_c('button', {
        staticClass: "md-btn pull-right",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.downloadPassengerDocument(passenger, document)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0), _vm._v(" "), _vm._m(2, true)])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-10 col-lg-10"
  }, [_c('voucher-list', {
    attrs: {
      "reservationId": _vm.reservationId,
      "travel-package-type": _vm.reservation.travel_package_type
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Reisdocumenten algemeen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('p', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('p', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a270dc"}!./src/templates/reservations/documents.html
// module id = 533
// module chunks = 1